(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vva-sale-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vva-sale-countdown')) {
  customElements.define('vva-sale-countdown', class extends HTMLElement {
    connectedCallback() {
      this.end = Date.parse(this.dataset.end);
      this.bar = this.querySelector('.vva-sale-bar');
      this.header = document.querySelector('#header.vva-header');
      this.fields = ['days', 'hours', 'minutes', 'seconds'].map(key => this.querySelector('[data-vva-time="' + key + '"]'));
      this.update = () => {
        const remaining = Math.max(0, Math.ceil((this.end - Date.now()) / 1000));
        this.hidden = !Number.isFinite(remaining) || remaining <= 0;
        if (this.hidden) {
          clearInterval(this.interval);
          this.position();
          return;
        }
        const values = [Math.floor(remaining / 86400), Math.floor(remaining / 3600) % 24, Math.floor(remaining / 60) % 60, remaining % 60];
        this.fields.forEach((field, i) => { field.textContent = String(values[i]).padStart(2, '0'); });
      };
      this.position = () => {
        const height = this.hidden ? 0 : Math.ceil(this.bar.getBoundingClientRect().height);
        this.style.setProperty('--vva-sale-height', height + 'px');
        const bottom = this.header ? this.header.getBoundingClientRect().bottom : height;
        const top = Math.max(height + 8, Math.min(bottom + 8, window.innerHeight - 140));
        document.documentElement.style.setProperty('--vva-sale-overlay-top', Math.ceil(top) + 'px');
      };
      this.inspectorOn = () => { this.dataset.inspector = ''; this.position(); };
      this.inspectorOff = () => { delete this.dataset.inspector; this.position(); };
      if (window.Shopify && window.Shopify.inspectMode) this.dataset.inspector = '';
      this.update();
      this.position();
      if (!this.hidden) this.interval = setInterval(this.update, 1000);
      this.observer = new ResizeObserver(this.position);
      this.observer.observe(this.bar);
      if (this.header) this.observer.observe(this.header);
      window.addEventListener('resize', this.position, { passive: true });
      window.addEventListener('scroll', this.position, { passive: true });
      document.addEventListener('visibilitychange', this.update);
      document.addEventListener('shopify:inspector:activate', this.inspectorOn);
      document.addEventListener('shopify:inspector:deactivate', this.inspectorOff);
    }
    disconnectedCallback() {
      clearInterval(this.interval);
      this.observer.disconnect();
      window.removeEventListener('resize', this.position);
      window.removeEventListener('scroll', this.position);
      document.removeEventListener('visibilitychange', this.update);
      document.removeEventListener('shopify:inspector:activate', this.inspectorOn);
      document.removeEventListener('shopify:inspector:deactivate', this.inspectorOff);
      document.documentElement.style.removeProperty('--vva-sale-overlay-top');
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
